"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EyeClosedIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const EyeClosedIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.707 4.707a1 1 0 0 0-1.414-1.414l-16 16a1 1 0 1 0 1.414 1.414l16-16ZM12 5c1.268 0 2.409.289 3.428.744L13.88 7.292A6.217 6.217 0 0 0 12 7c-1.92 0-3.524.881-4.903 2.066-1.005.864-1.803 1.802-2.515 2.638L4.331 12l.251.296c.602.707 1.265 1.486 2.062 2.231L5.23 15.942c-.894-.846-1.669-1.757-2.28-2.474-.257-.303-.486-.572-.682-.786a1.003 1.003 0 0 1 0-1.364c.196-.214.425-.483.683-.786.735-.864 1.71-2.009 2.842-2.983C7.369 6.196 9.42 5 12 5Zm0 3c.358 0 .7.053 1.02.151l-4.645 4.646A4.275 4.275 0 0 1 8.3 12c0-2.107 1.56-4 3.7-4Zm3.625 3.204-4.646 4.645c.321.098.663.151 1.02.151 2.14 0 3.7-1.893 3.7-4 0-.27-.025-.537-.074-.796ZM12 17a6.217 6.217 0 0 1-1.88-.291l-1.548 1.547c1.02.455 2.16.744 3.428.744 2.58 0 4.632-1.196 6.206-2.55 1.133-.973 2.108-2.118 2.843-2.982.258-.303.487-.572.683-.786a.997.997 0 0 0 0-1.364c-.196-.214-.425-.483-.683-.786-.61-.718-1.386-1.628-2.279-2.474l-1.414 1.415c.797.745 1.46 1.524 2.061 2.231l.252.296-.252.296c-.712.837-1.51 1.774-2.514 2.638C15.524 16.119 13.92 17 12 17Z"
}));
exports.EyeClosedIcon = EyeClosedIcon;